import React from 'react';
import ReactECharts from 'echarts-for-react';

const BarAndLineChart = ({ item }) => {
  //   const { xaxis_values, yaxis_values } = item?.data;

  const options = {
    title: {
      text: item.title.text || '',
      // textStyle: {
      //   fontSize: 13,
      // },
      left: 'center',
    },
    xAxis: {
      type: 'category',
      data: item.xAxis.data,
      name: item.xaxis_name || '',
      // nameTextStyle: {
      //   fontSize: 12,
      // },
      // nameLocation: 'middle',
      // nameGap: 30,
      axisLabel: {
        interval: 0,
        rotate: item.xAxis.data.length > 6 ? 45 : 0,
      },
    },
    yAxis: {
      type: 'value',
      name: item.yaxis_name || '',
      // nameTextStyle: {
      //   fontSize: 12,
      // },
      // nameLocation: 'middle',
      // nameGap: 60,
    },
    series: item.series,
    // series: [
    //   {
    //     type: item.type,
    //     data: item.series[0].data,
    //     barGap: '30%',
    //     itemStyle: {
    //       color: '#3398DB', // Custom color
    //     },
    //   },
    // ],
    grid: {
      containLabel: true,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
  };

  return (
    <ReactECharts
      option={options}
      style={{ width: 'auto', height: '350px' }}
      opts={{ renderer: 'svg' }} // Use 'canvas' for better performance
    />
  );
};

export default BarAndLineChart;
